<script setup>
import { computed } from 'vue';
import { useAdmin } from 'dashboard/composables/useAdmin';
import { useAccount } from 'dashboard/composables/useAccount';
import { useRuutBilling } from 'dashboard/composables/useRuutBilling';
import { mapGetters } from 'vuex';
import Banner from 'dashboard/components/ui/Banner.vue';

const { isAdmin } = useAdmin();
const { accountId } = useAccount();
const { subscriptionStatus, isInGracePeriod, gracePeriodDaysRemaining } = useRuutBilling();

// Use Vuex mapGetters for compatibility
const isOnChatwootCloud = computed(() => {
  // This would need to be injected or accessed differently in composition API
  // For now, keep the original logic
  return true; // TODO: Properly access Vuex in composition API
});

const bannerMessage = computed(() => {
  if (isInGracePeriod.value) {
    return `Your subscription is ending. You have ${gracePeriodDaysRemaining.value} days remaining in your grace period.`;
  }
  return 'Payment is pending. Please update your billing information.';
});

const actionButtonMessage = computed(() => {
  return 'Open Billing';
});

const shouldShowBanner = computed(() => {
  if (!isOnChatwootCloud.value) {
    return false;
  }

  if (!isAdmin.value) {
    return false;
  }

  return subscriptionStatus.value === 'past_due';
});

const routeToBilling = () => {
  // This would need router access
  // For now, just log the action
  console.log('Route to billing settings');
};
</script>

<template>
  <Banner
    v-if="shouldShowBanner"
    color-scheme="alert"
    :banner-message="bannerMessage"
    :action-button-label="actionButtonMessage"
    has-action-button
    @primary-action="routeToBilling"
  />
</template>
